import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInfoFullBlue = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="Info_full_blue"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle cx={10} cy={10} r={8} fill="url(#Info_full_blue_svg__a)" />
    <path
      fill="#fff"
      d="M11 6.2a1 1 0 1 1-1.999 0A1 1 0 0 1 11 6.2m-1.8 3a.8.8 0 1 1 1.6 0v4.4a.8.8 0 0 1-1.6 0z"
    />
    <defs>
      <linearGradient
        id="Info_full_blue_svg__a"
        x1={15}
        x2={-5}
        y1={13.75}
        y2={13.333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#256CF7" />
        <stop offset={1} stopColor="#C8D9FC" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgInfoFullBlue;
